const Class = require('sma.fs/chide/class');

let Variable = Class.create({
	type: undefined,
	id: undefined,
	label: undefined,

	initialize: function(config) {
		$.extend(this, config);
	},

	serialize: function() {
		return {
			id: this.id,
			type: this.type,
			label: this.label
		};
	}
});

Variable['String'] = Class.create(Variable, {
	type: 'string'
});

Variable['Boolean'] = Class.create(Variable, {
	type: 'boolean'
});

Variable['Choice'] = Class.create(Variable, {
	serialize: function($super) {
		return $.extend($super(), {
			choices: this.choices
		});
	}
});

Variable['Single'] = Class.create(Variable['Choice'], {
	type: 'single'
});

Variable['Multi'] = Class.create(Variable['Choice'], {
	type: 'multi'
});

Variable['DateTime'] = Class.create(Variable, {
	type: 'datetime'
});

Variable['SingleMeta'] = Class.create(Variable['Choice'], {
	type: 'single-meta'
});

Variable['File'] = Class.create(Variable, {
	type: 'file'
});

module.exports = Variable;
